import React from 'react'

export const IcoClose = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    {...props}
  >
    <g clip-path='url(#clip0_3093_72944)'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12.0001 13.5363L18.1455 19.6818C18.5697 20.1061 19.2576 20.1061 19.6818 19.6818C20.1061 19.2575 20.1061 18.5697 19.6818 18.1454L13.5364 12L19.6818 5.85456C20.1061 5.43031 20.1061 4.74246 19.6818 4.31821C19.2576 3.89395 18.5697 3.89395 18.1455 4.31821L12.0001 10.4637L5.85455 4.31819C5.4303 3.89394 4.74244 3.89394 4.31819 4.31819C3.89394 4.74245 3.89394 5.43029 4.31819 5.85455L10.4636 12L4.31819 18.1455C3.89394 18.5697 3.89394 19.2575 4.31819 19.6818C4.74244 20.1061 5.4303 20.1061 5.85455 19.6818L12.0001 13.5363Z'
      />
    </g>
    <defs>
      <clipPath id='clip0_3093_72944'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
